import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let cancel = false;
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancel) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "failed" || data.payment_status === "expired") { setStatus("failed"); return; }
        if (attempts.current < 20) setTimeout(poll, 1500);
        else setStatus("pending");
      } catch { if (!cancel) setStatus("error"); }
    };
    poll();
    return () => { cancel = true; };
  }, [sid]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid={TID.paymentSuccess}>
      <div className="text-center max-w-md">
        <CheckCircle2 size={56} className={`mx-auto ${status === "paid" ? "text-[color:var(--tropical-sea)]" : "text-[color:var(--forest-2)]"}`} />
        <h1 className="font-display text-4xl mt-6">
          {status === "paid" ? "You're in." : status === "checking" ? "Confirming your booking…" : status === "pending" ? "Still processing" : "Something went wrong"}
        </h1>
        <p className="text-[color:var(--forest-2)] mt-3">
          {status === "paid" ? "Confirmation and tickets are on their way to your inbox." : "This usually takes a few seconds."}
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/dashboard" className="btn-pill btn-primary">View my bookings</Link>
          <Link to="/" className="btn-pill btn-outline">Back home</Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid={TID.paymentCancel}>
      <div className="text-center max-w-md">
        <XCircle size={56} className="mx-auto text-[color:var(--terracotta)]" />
        <h1 className="font-display text-4xl mt-6">Checkout cancelled.</h1>
        <p className="text-[color:var(--forest-2)] mt-3">Your card wasn't charged. Ready when you are.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/events" className="btn-pill btn-primary">Back to events</Link>
          <Link to="/" className="btn-pill btn-outline">Home</Link>
        </div>
      </div>
    </div>
  );
}
